var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.643 6.595c.22.418.344.894.344 1.399 0 .439-.094.855-.263 1.231l3.265 3.462-.002-1.75a.973.973 0 0 1 .314-.68.99.99 0 0 1 1.388.048c.186.2.316.46.3.715l-.009 4.03a.959.959 0 0 1-.3.68.972.972 0 0 1-.698.266l-4.053.002a.97.97 0 0 1-.679-.314 1.031 1.031 0 0 1 .05-1.42.972.972 0 0 1 .698-.266l1.7-.001-3.305-3.35a2.998 2.998 0 0 1-4.228-1.653H.999a1 1 0 0 1 0-2h4.166a2.998 2.998 0 0 1 4.06-1.735l3.449-3.268-1.745.002a.979.979 0 0 1-.631-1.692c.199-.186.459-.316.713-.3l4.025.009c.247.008.493.1.679.3.186.2.274.451.265.7l.002 4.046a.972.972 0 0 1-.313.68 1.03 1.03 0 0 1-1.42-.05.973.973 0 0 1-.266-.7V3.295l-3.34 3.301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowBranch);
export default __webpack_public_path__ + "static/media/flow-branch.4a09784fbc734365ebaf5eb0f24df80c.svg";
export { ForwardRef as ReactComponent };